export default __webpack_public_path__ + "static/media/haveplan.b50d80f2.jpg";